export const imageEditorPresetSource = {
  beginDrag(props) {
    if (props.setDragging) props.setDragging(true);
    return { id: props.id, index: props.index };
  },

  endDrag(props, monitor) {
    if (props.setDragging) props.setDragging(false);
    if (monitor.didDrop()) {
      props.saveImageEditorPresets();
    }
  },

  canDrag(props) {
    return props.canDrag !== false;
  },
};

export const imageEditorPresetTarget = {
  hover(props, monitor) {
    const item = monitor.getItem();
    const dragIndex = item.index;
    const hoverIndex = props.index;

    const clientOffset = monitor.getClientOffset();
    const container = document.getElementsByClassName('main-content')[0];

    if (clientOffset && container) {
      if (clientOffset.y < container.offsetTop + 50) container.scrollBy(0, -5);
      if (clientOffset.y > container.offsetTop + container.offsetHeight - 50) {
        container.scrollBy(0, 5);
      }
    }

    if (dragIndex === hoverIndex) return;

    props.moveImageEditorPreset(dragIndex, hoverIndex);
    item.index = hoverIndex;
  },
};
